import React, { type FC } from 'react';

import type { Currency } from '../../types/customerApi';
import { CurrencyCode, CurrencyMode } from '../../types/customerApi';

type CurrencyDisplayProps = {
  currencyMode: CurrencyMode;
  currency?: Partial<Pick<Currency, 'code' | 'customCode'>>;
};

export const CurrencyDisplay: FC<CurrencyDisplayProps> = ({
  currencyMode,
  currency,
}) => {
  if (currencyMode === CurrencyMode.Multi) {
    return <span>Multiple</span>;
  }
  return (
    <span>
      {(currency?.code === CurrencyCode.Custom
        ? currency.customCode
        : currency?.code) ??
        /* Else, catch-all for invalid currencies */
        'Unknown'}
    </span>
  );
};
